import API from "./restAPI";
import { AxiosResponse } from "axios";

let config = require("../configuration.json");

export function apiImportPriceUploadFileWithPrices(formData: any): Promise<AxiosResponse> {
  return API.post(`${config.serverUrl}/api/importprice/upload`, formData);
}